import { Flex, Paper, Text, Title } from "@mantine/core";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";

interface Role {
  title: string;
  bgColor: string;
  description: string;
}

function mapUnexpectedRoles(roles: { title: string; description: string }[]): {
  roles_to_consider: Role[];
} {
  const roleColors = ["#3A8BD9", "#6F40E2", "#A64DD7"];

  return {
    roles_to_consider: roles.map((role, index) => ({
      title: role.title,
      bgColor: roleColors[index % roleColors.length],
      description: role.description,
    })),
  };
}

export const RolesToConsiderPDF = () => {
  const { report } = useReportStore();

  const content = report?.unexpected_roles || [];

  const rolesToConsider = mapUnexpectedRoles(content.data);

  return (
    <PDFPage padding>
      <Title size={48} mb={8}>
        {content?.mark_down ? content?.mark_down.replace("##", "") : ""}
      </Title>
      <Text mb={42} size="28px" lh="42px" c="dimmed">
        {content?.explanation ? content?.explanation : ""}
      </Text>
      <Flex c="#fff" direction="column" className="pdf-blocks">
        {rolesToConsider.roles_to_consider.map((role, index) => (
          <Paper
            key={index}
            bg={role.bgColor}
            p="44px"
            className={`block-${index + 1}`}
          >
            <Title order={3} size={28} lh="42px">
              {role.title}
            </Title>
            <Text mt={12} size="28px" lh="42px">
              {role.description}
            </Text>
          </Paper>
        ))}
      </Flex>
    </PDFPage>
  );
};
